<template>
	<Layout :loading="loading || saving" :pageTitle="title" :backlink="`/memberships/${$route.params.id}`">
		<FormulateForm v-model="form" name="form" ref="form" style="max-width:100%" @submit="save">
			<div class="main-container container" v-if="!loading">
				<div class="row row-xs mt-4 mb-4 pb-4">
					<div class="col-12 col-md-8 col-xl-6 m-auto">
						<div class="card ">
							<div class="card-body p-3">
								<h5 class="mb-0">Información básica</h5>
								<p class="text-secondary">
									Elige un nombre para tu membresía e ingresa la información básica
								</p>

								<!-- <FormulateInput
									label="Imagen principal"
									name="image"
									type="file"
									accept="images"
									listStyle="thumb"
									:displayBlock="true"
									help="Tamaño recomendado 640 x 480"
								/> -->

								<FormulateInput
									label="Nombre"
									name="name"
									validation-name="Nombre"
									validation="required"
								/>

								<FormulateInput
									label="Condiciones de membresía"
									type="wysiwyg"
									name="description"
									height="250"
									validation="required"
								/>

								<h5 class="mb-0 mt-5 pt-2">Condiciones de venta</h5>
								<p class="text-secondary">
									Define que tipo de membresía es y cuánto se cobra
								</p>

								<FormulateInput
									name="type"
									:options="{
										PERIOD: 'Por período de tiempo',
										RECURRENT: 'Recurrente',
										QUANTITY: 'Por ingresos'
									}"
									type="select"
									placeholder="Seleccione una opción"
									label="Tipo de membresía"
								/>
								<div class="row row-xs">
									<div class="col-6 mt-2" v-show="form.type == 'QUANTITY'">
										<FormulateInput
											type="number"
											label="Cantidad de ingresos"
											name="accessLimit"
											validation-name="Cantidad de ingresos por membresia"
											validation="required|number"
										/>
									</div>
									<div class="col-6 mt-2" v-show="form.type == 'PERIOD'">
										<FormulateInput
											type="date"
											label="Mantener activa hasta"
											name="validAt"
											:displayFormat="'DD-MM-YYYY HH:mm'"
											validation-name="Fecha límite de venta"
											:validation="`required`"
											class="flex-grow-1 mb-4"
										/>
									</div>
									<div class="col-6 mt-2">
										<FormulateInput
											class="mr-1"
											label="Precio"
											name="price"
											type="price"
											:currency="$store.getters.loggedAccount.currencySymbol"
											validation-name="Precio"
											validation="required"
											:help="
												`Precio comprador: ${
													$store.getters.loggedAccount.currencySymbol
												} ${addFeeToPrice()}`
											"
										/>
									</div>
									<div class="col-6 mt-2">
										<FormulateInput
											type="number"
											label="Cantidad disponible"
											name="limit"
											validation-name="Cantidad disponible"
											validation="required|number"
										/>
									</div>
								</div>

								<h5 class="mb-0 mt-5 pt-2">Condiciones de publicación</h5>
								<p class="text-secondary">
									Define durante que período de tiempo estará a la venta
								</p>

								<div class="row row-xs">
									<div class="col-6 mt-2">
										<FormulateInput
											type="date"
											label="Desde"
											name="publicFrom"
											:displayFormat="'DD-MM-YYYY HH:mm'"
											class="flex-grow-1 mb-4"
											validation-name="Fecha inicio de venta"
											:validation="`required|${form.publicTo ? 'before:' + form.publicTo : ''}`"
											:max="form.publicTo"
										/>
									</div>
									<div class="col-6 mt-2">
										<FormulateInput
											type="date"
											label="Hasta"
											name="publicTo"
											:displayFormat="'DD-MM-YYYY HH:mm'"
											validation-name="Fecha límite de venta"
											class="flex-grow-1 mb-4"
											:validation="
												`required|${form.publicFrom ? 'after:' + form.publicFrom : ''}`
											"
											:min="form.publicFrom"
										/>
									</div>
								</div>

								<hr />

								<div class="d-flex justify-content-between mt-4">
									<div class="btn btn-light" @click="$router.go(-1)">
										Cancelar
									</div>
									<div class="btn btn-primary disabled" v-if="saving">
										Guardando <span class="loader" />
									</div>
									<button type="submit" class="btn btn-primary" v-if="!saving">
										{{ btnAction }}
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</FormulateForm>
	</Layout>
</template>

<script>
import gql from "graphql-tag"
import mixins from "@/mixins/mixins"
import formMixins from "@/mixins/formMixins"

export default {
	name: "MembershipForm",
	components: {},
	mixins: [mixins, formMixins],
	data() {
		return {
			title: "Crear membresía",
			action: "create",
			btnAction: "Crear membresía",
			form: {
				type: "TEMPORADA",
				image: null,
				name: null,
				description: null,
				price: 0,

				validAt: null,
				publicFrom: this.$moment().toDate(),
				publicTo: null,
				limit: 0,
				accessLimit: 0
			},
			loading: true,
			saving: false
		}
	},

	async beforeMount() {
		this.loading = true

		if (this.$route.params.id) {
			this.action = "update"
			this.title = `Editar membresía`
			this.btnAction = "Guardar cambios"
			await this.load()
		}
		this.loading = false
	},

	methods: {
		addFeeToPrice() {
			const price = parseFloat(this.form.price)
			const fee = this.$store.getters.loggedAccount.fee
			return (price + price * (fee / 100)).toFixed(2)
		},

		async save() {
			this.saving = true

			let dataInput = {
				image: this.form.image ? this.form.image.id : null,
				name: this.form.name,
				description: this.form.description,
				type: this.form.type,
				price: this.form.price ? parseFloat(this.form.price) : 0,
				accessLimit: this.form.accessLimit > 0 ? parseInt(this.form.accessLimit) : 0,
				validAt: this.form.validAt,
				publicFrom: this.form.publicFrom,
				publicTo: this.form.publicTo,
				limit: this.form.limit ? parseInt(this.form.limit) : null
			}

			if (this.action == "create") {
				await this.create(dataInput)
			}
			if (this.action == "update") {
				await this.update(dataInput)
			}
			this.saving = false
		},

		create(data) {
			return this.$apollo
				.mutate({
					mutation: gql`
						mutation($data: MembershipTypeInput!) {
							membershipTypeCreate(data: $data) {
								id
							}
						}
					`,
					variables: {
						data
					}
				})
				.then(() => {
					this.$toast.success("Membresía creada correctamente")
					this.loading = false
					this.saving = false
					this.$router.go(-1)
				})
				.catch((error) => {
					this.parseGQLErrors(error)
					this.loading = false
				})
		},

		update(data) {
			return this.$apollo
				.mutate({
					mutation: gql`
						mutation($id: ID!, $data: MembershipTypeInput!) {
							membershipTypeUpdate(id: $id, data: $data) {
								id
							}
						}
					`,
					variables: {
						id: this.$route.params.id,
						data
					}
				})
				.then(() => {
					this.$toast.success("Membresía editada correctamente")
					this.saving = false
					this.$router.go(-1)
				})
				.catch((error) => {
					this.errors = this.parseGQLErrors(error)
				})
		},

		load() {
			return this.$apollo
				.query({
					query: gql`
						query($id: ID!) {
							membershipType(id: $id) {
								id
								name
								type
								image {
									id
									type
									filename
									url
									urlThumb
								}
								description
								price
								accessLimit
								limit
								validAt
								publicFrom
								publicTo
							}
						}
					`,
					variables: { id: this.$route.params.id },
					fetchPolicy: "network-only"
				})
				.then(({ data }) => {
					this.form = {
						...data.membershipType,
						validAt: this.$moment(data.membershipType.validAt).format("YYYY-MM-DD HH:mm:00"),
						publicFrom: this.$moment(data.membershipType.publicFrom).format("YYYY-MM-DD HH:mm:00"),
						publicTo: this.$moment(data.membershipType.publicTo).format("YYYY-MM-DD HH:mm:00")
					}
				})
				.catch(() => {
					this.$toast.error("El item que desea editar no existe")
					// this.$router.go(-1)
				})
		}
	}
}
</script>
